import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {  Share } from '@mui/icons-material';
import { shareTextOf } from '../utils/Universalfunctions';
import Loading from '../component/Loading';
import { ideasBatch } from './data';

const AdminExplore = ({ previewItems, loading }) => {

    const navigate = useNavigate();

    const [visibleCount, setVisibleCount] = useState(24);


    const itemsToshow = previewItems ? ideasBatch.slice(0, 9) : ideasBatch.slice(0, visibleCount);


    return (

        <>
            <div className='row row-gap-4'>
                {loading ? (
                    <div className='col-12 text-center'>
                        <div style={{ padding: '20px' }}>
                            <Loading text="Loading..." />
                        </div>
                    </div>
                ) : (
                    itemsToshow.map((item, i) => (
                        <div className={`col-md-${previewItems ? '4' : '3'}`} key={i}>

                            <div className={`explore-card ${item?.type === 'Problem' ? 'feature-problems' : 'feature-idea'}`}>
                                <div className="card-body">
                                    <span className="cat-tag types"> {item?.type || 'Idea'} </span>
                                    <span className="cat-tag"> {item?.category || 'General'} </span>

                                    <p className='heading-font'> {item?.title}</p>
                                    <p className='shortIKj'> {item?.problem?.slice(0, 100)}...</p>
                                </div>


                                <div className="comment-input-area">
                                    <div className='cia-skd'>
                                        <button
                                            className="interested-cta heading-font"
                                            onClick={() => {
                                                navigate(`/admin/interested/${item.id}`);
                                            }}
                                        >
                                            I'm Interested
                                        </button>
                                        <button onClick={() => shareTextOf(`${window.location.origin}/admin/interested/${item?.id}`)} type='button' className="share-btn"> <Share /> </button>

                                    </div>
                                    <p>
                                        This <span> {item?.type} </span> has been officially published by the Admin
                                    </p>
                                </div>

                            </div>
                        </div>

                    ))
                )}

                {!previewItems && visibleCount < ideasBatch.length && (
                    <div className='col-12'>
                        <div className="col-12 text-center mt-4">
                            <button
                                className="view-more-btn"
                                onClick={() => setVisibleCount(prev => prev + 24)}
                            >
                                + {ideasBatch?.length - itemsToshow?.length || 0} View More
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>

    );
};

export default AdminExplore;
